import { ADD_SALE_NOTIFICATION, REMOVE_SALE_NOTIFICATION } from '../constants/sale-notifications';

export const addSaleNotification = event => ({
  type: ADD_SALE_NOTIFICATION,
  payload: event,
});

export const removeSaleNotification = id => ({
  type: REMOVE_SALE_NOTIFICATION,
  payload: id,
});
